<template>
    <div v-if="password" class="flex justify-end text-2xs">
        <span
            class="font-medium mr-1"
            :class="{
                'text-bbk-claret': score <= 2,
                'text-bbk-gold': score === 3,
                'text-bbk-dark-green': score === 4,
            }"
        >
            {{ $t('Bbk.form.create.passwordStrength') }}:
            {{
                score <= 2
                    ? $t('Bbk.form.create.passwordWeak')
                    : score === 3
                    ? $t('Bbk.form.create.passwordMedium')
                    : $t('Bbk.form.create.passwordStrong')
            }}
        </span>
        <div class="flex items-center gap-[0.125rem] ml-px">
            <span
                v-for="(_, index) in dots"
                :key="`dot-${index}`"
                class="block w-[0.5rem] h-[0.5rem] rounded-full border"
                :class="[`create-password-dots__dot--${score}`]"
            ></span>
        </div>

        <PasswordMeter :password="password" @score="onScore" />
    </div>
</template>

<script setup lang="ts">
    import PasswordMeter from 'vue-simple-password-meter'
    import type { Props } from './props'

    withDefaults(defineProps<Props>(), {
        password: '',
    })

    const score = ref(0)
    const dots = 5

    function onScore(payload: { score: number; strength: string }) {
        score.value = payload.score
    }
</script>

<style scoped lang="scss">
    .po-password-strength-bar.risky,
    .po-password-strength-bar.guessable,
    .po-password-strength-bar.weak,
    .po-password-strength-bar.safe,
    .po-password-strength-bar.secure {
        width: 0;
    }

    .create-password-dots {
        &__dot {
            &--0,
            &--1,
            &--2 {
                @apply border-bbk-claret;

                &:nth-child(n + 4) {
                    @apply border-bbk-claret bg-bbk-claret;
                }
            }

            &--3 {
                @apply border-bbk-gold;

                &:nth-child(n + 3) {
                    @apply border-bbk-gold bg-bbk-gold;
                }
            }

            &--4 {
                @apply bg-bbk-dark-green border-bbk-dark-green;
            }
        }
    }
</style>
